import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Check, Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { NeuButton, NeuInput } from "../../../components/neu/Neu";
import { DateInput } from "../../../components/neu/DateInput";
import { updateHoliday } from "../../../api/directory";

// سطر عطلة رسمية: عرض، تعديل مباشر، استثناء من الفرع، وحذف.
export const HolidayRow = ({ item, excluded, onToggle, onDelete, reload }) => {
  const { t } = useTranslation();
  const [draft, setDraft] = useState(null);

  const save = async () => {
    try {
      await updateHoliday(item.id, {
        name: draft.name, name_ar: draft.name_ar || null,
        start_date: draft.start_date, end_date: draft.end_date || draft.start_date,
      });
      toast.success(t("holidays.updated"));
      setDraft(null);
      reload();
    } catch {
      toast.error(t("errors.generic"));
    }
  };

  if (draft) {
    return (
      <li className="grid gap-2 py-3 sm:grid-cols-5" data-testid={`holiday-edit-${item.id}`}>
        <NeuInput data-testid={`holiday-edit-name-${item.id}`} value={draft.name}
          onChange={(e) => setDraft({ ...draft, name: e.target.value })} />
        <NeuInput data-testid={`holiday-edit-name-ar-${item.id}`} value={draft.name_ar ?? ""}
          onChange={(e) => setDraft({ ...draft, name_ar: e.target.value })} />
        <DateInput testId={`holiday-edit-start-${item.id}`} value={draft.start_date}
          onChange={(v) => setDraft({ ...draft, start_date: v })} />
        <DateInput testId={`holiday-edit-end-${item.id}`} value={draft.end_date ?? ""}
          onChange={(v) => setDraft({ ...draft, end_date: v })} />
        <div className="flex gap-2">
          <NeuButton type="button" variant="primary" className="px-3 py-2" data-testid={`holiday-save-${item.id}`} onClick={save}>
            <Check className="h-4 w-4" />
          </NeuButton>
          <NeuButton type="button" className="px-3 py-2" data-testid={`holiday-cancel-${item.id}`} onClick={() => setDraft(null)}>
            {t("app.cancel")}
          </NeuButton>
        </div>
      </li>
    );
  }

  return (
    <li className="flex flex-wrap items-center justify-between gap-3 py-3">
      <div className="min-w-0">
        <p className="truncate text-sm font-semibold">
          {item.name} {item.name_ar ? <span className="text-muted-foreground">· {item.name_ar}</span> : null}
        </p>
        <p className="font-mono text-xs text-muted-foreground">
          {item.start_date} → {item.end_date} {item.recurring_yearly ? `· ${t("holidays.yearly")}` : ""}
          {item.source === "uae_default" ? " · UAE" : ""}
        </p>
      </div>
      <div className="flex items-center gap-2">
        <button
          type="button"
          data-testid={`holiday-exclude-${item.id}`}
          onClick={onToggle}
          className={`rounded-2xl border px-3 py-2 text-xs font-bold ${
            excluded ? "border-destructive/50 text-destructive shadow-neu-in" : "border-border/60 text-muted-foreground shadow-neu-sm"
          }`}
        >
          {excluded ? t("holidays.excluded") : t("holidays.applies")}
        </button>
        <NeuButton type="button" className="px-3 py-2" data-testid={`holiday-edit-btn-${item.id}`} onClick={() => setDraft(item)}>
          <Pencil className="h-4 w-4" />
        </NeuButton>
        <NeuButton type="button" variant="danger" className="px-3 py-2" data-testid={`holiday-delete-${item.id}`} onClick={onDelete}>
          <Trash2 className="h-4 w-4" />
        </NeuButton>
      </div>
    </li>
  );
};
